import { useMemo } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { categoryMap } from '@/mocks/content';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb() {
  const location = useLocation();

  const breadcrumbs = useMemo<BreadcrumbItem[]>(() => {
    const items: BreadcrumbItem[] = [{ label: '首页', href: '/' }];
    const pathParts = location.pathname.split('/').filter(Boolean);

    if (pathParts[0] === 'category' && pathParts[1]) {
      const cat = categoryMap[pathParts[1]];
      if (cat) {
        items.push({ label: cat.label, href: `/category/${cat.slug}` });
      }
    } else if (pathParts[0] === 'detail' && pathParts[1]) {
      items.push({ label: '影片详情' });
    } else if (pathParts[0] === 'about') {
      items.push({ label: '关于我们' });
    }

    return items;
  }, [location.pathname]);

  return (
    <nav aria-label="面包屑导航" className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {breadcrumbs.map((item, index) => (
          <li key={index} className="flex items-center">
            {index > 0 && (
              <span className="mx-2 text-foreground-400" aria-hidden="true">/</span>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-primary-500 transition-colors duration-200"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}